import { merge } from 'shared/utils/mergeObjects'
import { ICommonListModel } from 'shared/models/Common'
import { ISortOrderEnum } from 'shared/models/List'
import {
  ResidentContactsSortFieldEnum,
  IResidentContact,
  OtherContactsSortFieldEnum,
  BoardContactsSortFieldEnum,
} from 'Modules/Communication/Contacts/shared/models/Contacts'
import {
  CONTACTS_FETCH_OTHERS_ERROR,
  CONTACTS_FETCH_OTHERS_REQUESTED,
  CONTACTS_FETCH_OTHERS_SUCCESS,
  CONTACTS_FETCH_RESIDENTS_ERROR,
  CONTACTS_FETCH_RESIDENTS_REQUESTED,
  CONTACTS_FETCH_RESIDENTS_SUCCESS,
  CONTACTS_SET_SEARCHTEXT,
  CONTACTS_SET_SECTION,
  CONTACT_UNITS_FETCH_ERROR,
  CONTACT_UNITS_FETCH_REQUESTED,
  CONTACT_UNITS_FETCH_SUCCESS,
  CONTACT_UNITS_RESET,
  CONTACT_UPDATE_ERROR,
  CONTACT_UPDATE_REQUESTED,
  CONTACT_UPDATE_SUCCESS,
  CONTACTS_FETCH_BOARDCONTACTS_ERROR,
  CONTACTS_FETCH_BOARDCONTACTS_REQUESTED,
  CONTACTS_FETCH_BOARDCONTACTS_SUCCESS,
  CONTACTS_FETCH_BOARDCONTACT_REQUESTED,
  CONTACTS_FETCH_BOARDCONTACT_SUCCESS,
  CONTACTS_FETCH_BOARDCONTACT_ERROR,
  CONTACTS_MANAGE_BOARDCONTACT_REQUESTED,
  CONTACTS_MANAGE_BOARDCONTACT_SUCCESS,
  CONTACTS_MANAGE_BOARDCONTACT_ERROR,
  CONTACTS_MANAGE_BOARDCONTACT_RESET,
  CONTACTS_RESIDENTS_SET_FILTERS,
  CONTACTS_BOARDCONTACTS_SET_FILTERS,
  CONTACTS_OTHERS_SET_FILTERS,
} from './actionTypes'
import { ContactsActionTypes } from './types'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'

const initialState = {
  residents: {
    data: null,
    loading: true,
    processing: false,
    error: null,
    processingError: null,
    section: null,
    filters: {
      sortcolumn: ResidentContactsSortFieldEnum.Name,
      sortorder: ISortOrderEnum.asc,
      take: DEFAULT_PAGE_TAKE,
      skip: 0,
    },
    unitsDetails: {
      data: null,
      loading: false,
      error: null,
    },
  },
  boards: {
    data: null,
    loading: false,
    manage: null,
    error: null,
    processing: false,
    processingError: false,
    success: false,
    filters: {
      sortcolumn: BoardContactsSortFieldEnum.Name,
      sortorder: ISortOrderEnum.asc,
      take: DEFAULT_PAGE_TAKE,
      skip: 0,
    },
  },
  others: {
    data: null,
    loading: false,
    error: null,
    filters: {
      sortcolumn: OtherContactsSortFieldEnum.Name,
      sortorder: ISortOrderEnum.asc,
      take: DEFAULT_PAGE_TAKE,
      skip: 0,
    },
  },
  searchText: null,
}

const reducer = (state = initialState, action: ContactsActionTypes) => {
  switch (action.type) {
    case CONTACTS_FETCH_RESIDENTS_REQUESTED:
      return {
        ...state,
        residents: {
          ...state.residents,
          loading: true,
          error: null,
        },
      }
    case CONTACTS_FETCH_RESIDENTS_SUCCESS:
      return {
        ...state,
        residents: {
          ...state.residents,
          loading: false,
          data: action.payload,
        },
      }
    case CONTACTS_FETCH_RESIDENTS_ERROR:
      return {
        ...state,
        residents: {
          ...state.residents,
          data: [],
          loading: false,
          error: action.payload,
        },
      }
    case CONTACTS_FETCH_OTHERS_REQUESTED:
      return {
        ...state,
        others: {
          ...state.others,
          loading: true,
          error: null,
        },
      }
    case CONTACTS_FETCH_OTHERS_SUCCESS:
      return {
        ...state,
        others: {
          ...state.others,
          loading: false,
          data: action.payload,
        },
      }
    case CONTACTS_FETCH_OTHERS_ERROR:
      return {
        ...state,
        others: {
          ...state.others,
          data: [],
          loading: false,
          error: action.payload,
        },
      }
    case CONTACTS_FETCH_BOARDCONTACTS_REQUESTED:
      return {
        ...state,
        boards: {
          ...state.boards,
          loading: true,
          error: null,
        },
      }
    case CONTACTS_FETCH_BOARDCONTACTS_SUCCESS:
      return {
        ...state,
        boards: {
          ...state.boards,
          loading: false,
          data: action.payload,
        },
      }
    case CONTACTS_FETCH_BOARDCONTACTS_ERROR:
      return {
        ...state,
        boards: {
          ...state.boards,
          data: [],
          loading: false,
          error: action.payload,
        },
      }
    case CONTACTS_FETCH_BOARDCONTACT_REQUESTED:
      return {
        ...state,
        boards: {
          ...state.boards,
          loading: true,
          error: null,
        },
      }
    case CONTACTS_FETCH_BOARDCONTACT_SUCCESS:
      return {
        ...state,
        boards: {
          ...state.boards,
          loading: false,
          manage: action.payload,
        },
      }
    case CONTACTS_FETCH_BOARDCONTACT_ERROR:
      return {
        ...state,
        boards: {
          ...state.boards,
          manage: null,
          loading: false,
          error: action.payload,
        },
      }
    case CONTACTS_MANAGE_BOARDCONTACT_REQUESTED:
      return {
        ...state,
        boards: {
          ...state.boards,
          processing: true,
          processingError: null,
          success: false,
        },
      }
    case CONTACTS_MANAGE_BOARDCONTACT_SUCCESS:
      return {
        ...state,
        boards: {
          ...state.boards,
          processing: false,
          success: true,
        },
      }
    case CONTACTS_MANAGE_BOARDCONTACT_ERROR:
      return {
        ...state,
        boards: {
          ...state.boards,
          processing: false,
          processingError: action.payload,
        },
      }
    case CONTACTS_MANAGE_BOARDCONTACT_RESET:
      return {
        ...state,
        boards: {
          ...state.boards,
          manage: null,
          processing: false,
          processingError: null,
          success: false,
        },
      }
    case CONTACTS_SET_SECTION:
      return {
        residents: {
          ...state.residents,
          ...state,
          section: action.payload,
        },
      }

    case CONTACT_UNITS_FETCH_REQUESTED: {
      return merge(state, {
        residents: {
          unitsDetails: {
            data: null,
            loading: true,
            error: null,
          },
        },
      })
    }
    case CONTACT_UNITS_FETCH_SUCCESS: {
      return merge(state, {
        residents: {
          unitsDetails: {
            data: action.payload,
            loading: false,
            error: null,
          },
        },
      })
    }

    case CONTACT_UNITS_FETCH_ERROR: {
      return merge(state, {
        residents: {
          unitsDetails: {
            data: null,
            loading: false,
            error: action.payload,
          },
        },
      })
    }

    case CONTACT_UNITS_RESET:
      return {
        ...state,
        residents: {
          ...state.residents,
          processing: false,
          processingError: null,
          unitsDetails: {
            data: null,
            loading: false,
            error: null,
          },
        },
      }
    case CONTACT_UPDATE_REQUESTED:
      return {
        ...state,

        residents: {
          ...state.residents,
          processing: true,
          processingError: null,
        },
      }
    case CONTACT_UPDATE_SUCCESS: {
      const owners = state.residents
        .data as unknown as ICommonListModel<IResidentContact>
      const owner = owners.result.find(
        (x) => x.nameregisterId === action.payload.nameId
      )

      if (owner) {
        owner.email = action.payload.values.email
        owner.mobile = action.payload.values.phonenumber
      }

      return {
        ...state,
        residents: {
          ...state.residents,
          data: owners,
          processing: false,
        },
      }
    }
    case CONTACT_UPDATE_ERROR:
      return {
        ...state,
        residents: {
          ...state.residents,
          processing: false,
          processingError: action.payload,
        },
      }

    case CONTACTS_RESIDENTS_SET_FILTERS:
      return {
        ...state,
        residents: {
          ...state.residents,
          filters: action.payload,
        },
      }
    case CONTACTS_BOARDCONTACTS_SET_FILTERS:
      return {
        ...state,
        boards: {
          ...state.boards,
          filters: action.payload,
        },
      }
    case CONTACTS_OTHERS_SET_FILTERS:
      return {
        ...state,
        others: {
          ...state.others,
          filters: action.payload,
        },
      }
    case CONTACTS_SET_SEARCHTEXT:
      return {
        ...state,
        searchText: action.payload,
        residents: {
          ...state.residents,
          filters: {
            ...state.residents.filters,
            skip: 0,
          },
        },
        others: {
          ...state.others,
          filters: {
            ...state.others.filters,
            skip: 0,
          },
        },
        boards: {
          ...state.boards,
          filters: {
            ...state.boards.filters,
            skip: 0,
          },
        },
      }

    default:
      return state
  }
}

export default reducer
